"use client"

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport, variantIconMap } from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant, ...props }) => {
        const resolvedVariant = variant || "default"
        const iconConfig = variantIconMap[resolvedVariant]

        return (
          <Toast key={id} variant={variant} {...props}>
            {iconConfig && (
              <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full mt-0.5 ${iconConfig.className}`}>
                <iconConfig.icon weight="bold" className="h-3 w-3" />
              </div>
            )}
            <div className="grid gap-0.5 flex-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
            {iconConfig && (
              <div
                className={`absolute bottom-0 left-0 h-0.5 rounded-tr-sm ${iconConfig.progressClassName}`}
                style={{ animation: "toast-progress 4s linear forwards" }}
              />
            )}
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
